import common from './common';
export default {
  // localUrl: 'http://zkcx.cxstar.cn',
  // baseUrl: 'http://zkcx.cxstar.cn',
  // localUrl: 'https://www.knowledgesource.cn',
  // baseUrl: 'https://www.knowledgesource.cn',
  // fileUrl: 'https://file.cxstar.cn',
  // localUrl: common.localUrl,
  baseUrl: common.baseUrl,
  fileUrl: common.fileUrl
}



// WEBPACK FOOTER //
// ./src/utils/url.js